import { Component, Input } from '@angular/core';
import { BookingDTO } from '@lkp/parking-sdk';
import { Subject, takeUntil } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Store } from '@ngxs/store';
import { UsersState } from 'src/app/core/states/users/users.state';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent {
  @Input() bookingsGroup?: any[];
  @Input() currentDirection: 'arrival' | 'departure' = 'arrival';
  searchResult?: any;
  termNotFound?: string;
  searchInput = new FormControl<string | undefined>(undefined);
  showSpinner: boolean = false;
  readonly onDestroy$ = new Subject<void>();
  isDriverMode: boolean = false;
  
  constructor(private store: Store) {}

  ngOnChanges(): void {
    this.termNotFound = undefined;
    this.searchResult = undefined;
    this.searchInput.setValue(undefined);
  }

  ngOnInit(): void {
    this.store
      .select(UsersState.driverMode)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((dm) => (this.isDriverMode = dm));
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  search(term: string | undefined): void {
    if (term === undefined || !term.trim().length || term === '') {
      this.termNotFound = undefined;
      this.searchResult = undefined;
      this.showSpinner = false;
    } else {
      this.showSpinner = true;
      this.filter(term);
    }
  }

  filter(term: string) {
    // Group is type FlightBookingDTO or HourBookingDTO
    this.showSpinner = false;

    const sourceGroups: any[] | undefined = this.bookingsGroup?.filter(
      (group) =>
        !(
          this.isDriverMode &&
          ((this.currentDirection === 'arrival' && this.isCallCustomersGroup(group)) ||
            (this.currentDirection === 'departure' && this.isNoShowsGroup(group)))
        )
    );

    const matches: BookingDTO[] | undefined = sourceGroups?.flatMap((group) =>
      group.bookings.filter(
        (booking: BookingDTO) =>
          (booking?.registrationNumber
            ?.replaceAll(/\s/g, '')
            ?.toLowerCase()
            .includes(term.replaceAll(/\s/g, '').toLowerCase()) ||
            booking.qr?.toLowerCase().includes(term.toLowerCase())) &&
          ((this.currentDirection === 'arrival' &&
            booking.qtyPersons !== booking?.qtyPersonsPickedUp) ||
            (this.currentDirection === 'departure' &&
              booking.qtyPersons !== booking?.qtyPersonsDroppedOff))
      )
    );

    this.searchResult = matches;

    if (!this.searchResult?.length) {
      this.termNotFound = term;
      this.searchResult = undefined;
    }
  }

  private isCallCustomersGroup(group: any): boolean {
    return !group?.flightNumber && group?.departureAirport
      ? group.departureAirport === 'Ringkunder'
      : false;
  }

  private isNoShowsGroup(group: any): boolean {
    // HourBookingDTO bucket that represents "Ringkunder" semantics in Bokningar
    return group?.hourBookingType === 'NO_SHOWS';
  }

  getTotalPassengers(bookings: BookingDTO[]): number {
    return bookings.reduce(
      (acc: number, booking: BookingDTO) => (booking.qtyPersons || 0) + acc,
      0
    );
  }
}
